import { useState } from "react";
import { Icon } from "../Icon.jsx";
import { methodStages } from "../../data/consultantCourse.js";

export function MethodCanvas() {
  const [activeId, setActiveId] = useState("ai");
  const activeStage = methodStages.find((stage) => stage.id === activeId) ?? methodStages[2];

  return (
    <section className="method-canvas" aria-label="Metodo di lavoro in cinque passaggi">
      <div className="method-canvas__steps" role="tablist" aria-label="Fasi del metodo">
        {methodStages.map((stage) => (
          <button
            aria-controls="method-stage-panel"
            aria-selected={stage.id === activeId}
            className={stage.id === activeId ? "method-step method-step--active" : "method-step"}
            id={`method-tab-${stage.id}`}
            key={stage.id}
            onClick={() => setActiveId(stage.id)}
            role="tab"
            type="button"
          >
            <span className="method-step__number">{stage.number}</span>
            <Icon name={stage.icon} size={21} />
            <strong>{stage.label}</strong>
          </button>
        ))}
      </div>

      <div
        aria-labelledby={`method-tab-${activeStage.id}`}
        className="method-canvas__workspace"
        id="method-stage-panel"
        role="tabpanel"
      >
        <div className="artifact-list" aria-label="Artefatti del percorso">
          <span>Artefatti</span>
          {["Dossier di analisi", "Mappa interlocutori", "Opzioni strategiche", "Piano d’azione"].map((item, index) => (
            <div className={index === 0 ? "artifact-list__item artifact-list__item--active" : "artifact-list__item"} key={item}>
              <Icon name={index === 0 ? "file" : "document"} size={17} />
              <span>{item}</span>
            </div>
          ))}
        </div>

        <div className="artifact-preview">
          <header>
            <div>
              <span>{activeStage.label}</span>
              <h2>{activeStage.artifact}</h2>
            </div>
            <small>v1.2</small>
          </header>
          <p>{activeStage.title}</p>
          <div className="artifact-preview__lines" aria-hidden="true">
            <i /><i /><i /><i />
          </div>
          <strong>Elementi chiave</strong>
          <ul>
            <li>Obiettivo e destinatario visibili</li>
            <li>Dati mancanti trasformati in domande</li>
            <li>Decisione e revisione restano umane</li>
          </ul>
        </div>

        <aside className="artifact-context">
          <span>Brief di riferimento</span>
          <p>{activeStage.description}</p>
          <div className="artifact-context__files">
            <div><Icon name="file" size={18} /><span>Contratto di incarico<small>PDF</small></span></div>
            <div><Icon name="document" size={18} /><span>Materiali cliente<small>DOCX</small></span></div>
            <div><Icon name="checkCircle" size={18} /><span>Criteri di qualità<small>CHECKLIST</small></span></div>
          </div>
        </aside>
      </div>
    </section>
  );
}
